import { ref, watch, nextTick } from 'vue';


export default {
  __name: 'TooltipButton',
  setup(__props, { expose }) {
  expose();

const isVisible = ref(false);
const tooltip = ref(null);
const isOverflowing = ref(false);
const overflowDirection = ref(null);
const viewportWidth = ref(window.innerWidth);

const toggleVisible = () => {
    if (isVisible.value === false) {
        isOverflowing.value = false;
    }
    viewportWidth.value = window.innerWidth;
    if (window.innerWidth <= 1024) {
        isVisible.value = !isVisible.value;
    }
};

document.addEventListener('click', (el) => {
    el.stopPropagation();
    if (
        el.target.tagName.toLowerCase() !== 'svg' &&
        el.target.tagName.toLowerCase() !== 'path' &&
        window.innerWidth <= 1024 &&
        isVisible.value
    ) {
        isVisible.value = false;
    }
});

const onMouseEnter = () => {
    viewportWidth.value = window.innerWidth;
    if (window.innerWidth > 1024) {
        isVisible.value = true;
    }
};

const onMouseLeave = () => {
    if (window.innerWidth > 1024) {
        isVisible.value = false;
    }
};

watch(isVisible, async (newVal) => {
    if (newVal) {
        await nextTick();
        checkOverflow();
    }
});

const checkOverflow = () => {
    if (tooltip.value) {
        const rect = tooltip.value.getBoundingClientRect();

        if (rect.left < 0) {
            isOverflowing.value = true;
            overflowDirection.value = 'left';
        } else if (rect.right > viewportWidth.value) {
            isOverflowing.value = true;
            overflowDirection.value = 'right';
        } else {
            isOverflowing.value = false;
            overflowDirection.value = null;
        }
    }
};

const __returned__ = { isVisible, tooltip, isOverflowing, overflowDirection, viewportWidth, toggleVisible, onMouseEnter, onMouseLeave, checkOverflow, ref, watch, nextTick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}